import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';

/**
 * Internal-linking section that lists 3 geographically-near cities.
 * Used by CityPage. Receives a fully-resolved `cities` array
 * (already mapped from slugs to city objects) and a `countyName` label.
 */
const NearbyCitiesSection = ({ cities, countyName }) => (
  <section className="bg-[#0b1e4d] py-14 text-white">
    <div className="max-w-[1280px] mx-auto px-5">
      <div className="text-center mb-10">
        <p className="text-[#bcd5f5] tracking-[0.3em] text-xs uppercase mb-2">
          Continue Exploring
        </p>
        <h2 className="font-serif text-3xl md:text-4xl font-bold">
          Nearby Cities We Also Serve
        </h2>
      </div>

      <nav
        aria-label="Nearby cities"
        data-testid="nearby-nav"
        className="grid grid-cols-1 md:grid-cols-3 gap-5"
      >
        {cities.map((n) => (
          <Link
            key={n.slug}
            to={`/pool-builder/${n.slug}/`}
            data-testid={`nearby-link-${n.slug}`}
            title={`Pool builder in ${n.displayName}`}
            className="group bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/30 rounded-sm p-6 transition-colors"
          >
            <div className="flex items-center gap-2 text-[#bcd5f5] text-xs uppercase tracking-wider mb-2">
              <MapPin className="w-4 h-4" /> {countyName}
            </div>
            <h3 className="font-serif text-xl font-bold mb-1">{n.name}</h3>
            <p className="text-sm text-white/80 mb-4">
              Pool builder in {n.name}
            </p>
            <span className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#bcd5f5] group-hover:text-white">
              View {n.name} <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        ))}
      </nav>

      <div className="text-center mt-8">
        <Link
          to="/#cities"
          className="inline-flex items-center gap-2 text-[#bcd5f5] hover:text-white font-semibold text-sm"
        >
          View all {countyName} service areas <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default NearbyCitiesSection;
